import React from "react";
import styles from "./Topbar.module.scss";

// Components
import Navbar from "../Navbar";

const Topbar = () => {
  return (
    <div className={styles.Topbar}>
      <Navbar />
    </div>
  );
};

export default Topbar;
